module.exports = __webpack_public_path__ + "static/media/favicon.91e64a28.svg";